"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarkNotificationAsReadDto = exports.NotificationsResponseDto = exports.NotificationResponseDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const paginated_dto_1 = require("../pagination/paginated.dto");
const notifications_interface_1 = require("./notifications.interface");
class NotificationResponseDto {
}
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], NotificationResponseDto.prototype, "_id", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], NotificationResponseDto.prototype, "type", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], NotificationResponseDto.prototype, "payload", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], NotificationResponseDto.prototype, "createdAt", void 0);
exports.NotificationResponseDto = NotificationResponseDto;
class NotificationsResponseDto {
    constructor(data, meta) {
        this.meta = new paginated_dto_1.PaginatedResponseDto(meta);
        this.notifications = (0, class_transformer_1.plainToInstance)(NotificationResponseDto, data, { excludeExtraneousValues: true });
    }
}
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => NotificationResponseDto),
    __metadata("design:type", Array)
], NotificationsResponseDto.prototype, "notifications", void 0);
exports.NotificationsResponseDto = NotificationsResponseDto;
class MarkNotificationAsReadDto {
}
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, class_validator_1.ArrayUnique)(),
    (0, class_validator_1.IsMongoId)({ each: true }),
    __metadata("design:type", Array)
], MarkNotificationAsReadDto.prototype, "ids", void 0);
exports.MarkNotificationAsReadDto = MarkNotificationAsReadDto;
//# sourceMappingURL=notifications.dto.js.map